@if (layoutNapis) {
  <main class="napis-login" [@esvanecerDesvanecer]="'in'">
    <section class="brand-panel" aria-label="Napis Force">
      <img class="brand-logo" [src]="logomarca" alt="Napis Force" width="480" height="160" />
      <h1>Gestão de vendas<br />que <span>conecta resultados</span></h1>

      <div class="brand-art" aria-hidden="true">
        <svg class="connection-lines" viewBox="0 0 900 900" preserveAspectRatio="xMidYMid slice" focusable="false">
          <g fill="none" stroke="#17b7ec" stroke-width="1.2" opacity=".7">
            <path d="M-80 480 C160 810 410 560 550 410 S700 95 980 130" />
            <path d="M-80 720 C220 380 350 790 580 340 S760 165 980 200" />
            <path d="M-80 560 C190 570 250 820 450 650 S700 470 980 290" />
          </g>
          <g fill="#52e2ff">
            <circle cx="78" cy="624" r="7" /><circle cx="397" cy="699" r="5" />
            <circle cx="508" cy="493" r="7" /><circle cx="624" cy="322" r="5" />
            <circle cx="868" cy="137" r="6" />
          </g>
          <g fill="#ffda36"><circle cx="754" cy="206" r="5" /><circle cx="804" cy="635" r="6" /></g>
        </svg>
        <div class="chart-card chart-bars">
          <div class="skeleton-line"></div>
          <div class="bars"><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>
        </div>
        <div class="chart-card chart-donut"><div class="donut"></div><div class="chart-labels"><i></i><i></i><i></i></div></div>
        <div class="chart-card chart-list"><div><b></b><i></i></div><div><b></b><i></i></div><div><b></b><i></i></div></div>
        <div class="chart-card chart-trend">
          <div class="skeleton-line"></div><div class="skeleton-line short"></div>
          <svg viewBox="0 0 300 150" focusable="false">
            <defs><linearGradient id="login-chart-fill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#0a96e1" stop-opacity=".5" /><stop offset="100%" stop-color="#0a96e1" stop-opacity="0" /></linearGradient></defs>
            <path d="M10 135 Q40 125 60 111 T108 83 T161 58 T209 62 T282 12 L282 150 H10Z" fill="url(#login-chart-fill)" />
            <path d="M10 135 Q40 125 60 111 T108 83 T161 58 T209 62 T282 12" fill="none" stroke="#00a9f2" stroke-width="4" />
            <g fill="#27d5ed"><circle cx="60" cy="111" r="5" /><circle cx="108" cy="83" r="5" /><circle cx="161" cy="58" r="5" /><circle cx="209" cy="62" r="5" /></g><circle cx="282" cy="12" r="6" fill="#ffdc39" />
          </svg>
        </div>
      </div>
      <p class="brand-footer"><span></span>Tecnologia que impulsiona seu negócio</p>
    </section>

    <section class="form-panel" aria-labelledby="login-title">
      <div class="login-card">
        <header class="login-heading">
          <h2 id="login-title">Bem-vindo de volta</h2>
          <p>Acesse sua conta para continuar</p>
        </header>
        <form [formGroup]="formLogin" (ngSubmit)="acessar(false)">
          <div class="login-field">
            <label for="napis-email">E-mail</label>
            <div class="input-shell" [class.field-invalid]="enviado && f.email.errors?.required">
              <i class="fa fa-envelope-o" aria-hidden="true"></i>
              <input id="napis-email" type="email" name="email" formControlName="email" autocomplete="username" placeholder="seu@exemplo.com" autocapitalize="none" spellcheck="false" [attr.aria-invalid]="enviado && f.email.errors?.required ? 'true' : null" [attr.aria-describedby]="enviado && f.email.errors?.required ? 'email-error' : null" />
            </div>
            @if (enviado && f.email.errors?.required) {
              <p id="email-error" class="field-error" role="alert">Informe seu e-mail.</p>
            }
          </div>
          <div class="login-field">
            <label for="napis-senha">Senha</label>
            <div class="input-shell" [class.field-invalid]="enviado && f.senha.errors?.required">
              <i class="fa fa-lock" aria-hidden="true"></i>
              <input id="napis-senha" [type]="mostrarSenha ? 'text' : 'password'" name="senha" formControlName="senha" autocomplete="current-password" placeholder="Digite sua senha" [attr.aria-invalid]="enviado && f.senha.errors?.required ? 'true' : null" [attr.aria-describedby]="enviado && f.senha.errors?.required ? 'senha-error' : null" />
              <button class="password-toggle" type="button" (click)="mostrarSenha = !mostrarSenha" [attr.aria-label]="mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'" [attr.aria-pressed]="mostrarSenha"><i class="fa" [class.fa-eye]="!mostrarSenha" [class.fa-eye-slash]="mostrarSenha" aria-hidden="true"></i></button>
            </div>
            @if (enviado && f.senha.errors?.required) {
              <p id="senha-error" class="field-error" role="alert">Informe sua senha.</p>
            }
          </div>
          <button class="login-submit" type="submit">Entrar <i class="fa fa-long-arrow-right" aria-hidden="true"></i></button>
        </form>
        <p class="secure-access"><i class="fa fa-shield" aria-hidden="true"></i> Acesso seguro</p>
        <footer class="login-footer">
          <p>Precisa de ajuda? <a [href]="suporteLoginUrl" target="_blank" rel="noopener noreferrer">Fale com nosso suporte <i class="fa fa-whatsapp" aria-hidden="true"></i><span class="sr-only"> (abre em nova aba)</span></a></p>
          <small>© {{ anoAtual }} Napis</small>
        </footer>
      </div>
    </section>
  </main>
} @else {
<div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
  <div class="login" [ngStyle]="{ 'background-color' : corFundo }">
    <div class="col-sm-12 text-center pt-4 pb-3">
      <div class="texto_superior pb-2" [ngStyle]="{ 'color' : corMensagem }">Seja Bem-Vindo ao Portal</div>

      <img class="logo_externo" [src]="logomarca" alt="Logomarca" />
    </div>

    <div class="d-flex justify-content-center">
      <div class="col-sm-4">
        <form [formGroup]="formLogin" (ngSubmit)="acessar(false)">
          <div class="form-group">
            <label [ngStyle]="{ 'color' : corTexto }"><b>E-mail:</b></label>

            <input class="form-control form-control-sm" type="email" name="email" [ngClass]="{ 'is-invalid' : enviado && f.email.errors?.required }" formControlName="email" />

            @if (enviado && f.email.errors?.required) {
              <div class="erro pt-1">E-mail em branco!</div>
            }
          </div>

          <div class="form-group">
            <label [ngStyle]="{ 'color' : corTexto }"><b>Senha:</b></label>

            <input class="form-control form-control-sm" type="password" name="senha" [ngClass]="{ 'is-invalid' : enviado && f.senha.errors?.required }" formControlName="senha" />

            @if (enviado && f.senha.errors?.required) {
              <div class="erro pt-1">Senha em branco!</div>
            }
          </div>

          <hr class="mt-2 mb-2" />

          <div class="col-sm-12 text-center p-0">
            <button class="btn btn-info btn_externo" type="submit">Acessar</button>
          </div>
        </form>

        <!--
        <div class="col-sm-12 text-center pt-4">
          <a routerLink="/recuperar-senha">Esqueci minha senha</a>
        </div>
        -->
      </div>
    </div>
  </div>
</div>
}
